/**
 * 持卡人端 i18n 资源装配（生产与自动化检查共用）
 *
 * 契约：整份 locale JSON 挂到单一 namespace `translation`，
 * 调用方使用点分路径 t('dashboard.nav.cards') / t('common.langZh')，
 * 与 useTranslation() 默认 NS 一致，禁止再按顶层 key 拆多 namespace。
 */
import zh from './locales/zh.json';
import en from './locales/en.json';

/** localStorage 语言偏好键 */
export const CHD_LANG_STORAGE_KEY = 'allinks_chd_lang';

/**
 * 默认 / 非法值回落语言。
 * N3 裁决（sprint-contract §9）：ChdLang 仅 'zh'|'en'，'zh' 映射语义等价 PRD「默认 zh-CN」。
 */
export const CHD_FALLBACK_LANG = 'zh' as const;

export type ChdLang = 'zh' | 'en';

/**
 * 解析存储的语言偏好：仅接受 zh | en，其余（含 null/非法）回落 zh（N3）。
 */
export function resolveChdLang(raw: string | null | undefined): ChdLang {
  return raw === 'en' ? 'en' : 'zh';
}

/**
 * 构建 i18next resources（与线上一致）。
 */
export function buildChdI18nResources() {
  return {
    zh: { translation: zh },
    en: { translation: en },
  };
}

/** 生产 init 共用的 i18next 静态选项（不含 lng / 插件） */
export const CHD_I18N_OPTIONS = {
  fallbackLng: CHD_FALLBACK_LANG,
  defaultNS: 'translation',
  ns: ['translation'],
  resources: buildChdI18nResources(),
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
} as const;
